import React, { forwardRef, useRef } from "react";

import { makeStyles } from "tss-react/mui";

import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Grid from "@mui/material/Grid";
import ZoomInMapIcon from "@mui/icons-material/ZoomInMap";

import Slide from "@mui/material/Slide";
import Typography from "@mui/material/Typography";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import KMKDialog from "./KMKDialog";
import ComponentSuspense from "./ComponentSuspense";

const MyAceEditor = React.lazy(() => import("./AceEditor"));

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles()((theme) => ({
  container: {
    padding: "24px 24px 24px 24px",
    backgroundColor: "#FFFFFF",
    height: "99%",
  },
  bodyContainer: {
    width: "100%",
    height: "100%",
    marginLeft: "0",
    marginBottom: "30px",
    display: "inline-table",
  },
  Toolbar: {
    backgroundColor: "white",
    color: "black",
    padding: 0,
  },
  dialogContent: {
    padding: "0",
    overflow: "auto",
  },
  queryArea: {
    width: "100% !important",
    border: "1px solid",
    fontSize: "0.7rem",
    "&::selection": { background: "#B9B9B9", color: "#000000" },
    "&::-moz-selection": { background: "#B9B9B9", color: "#000000" },
    "&::-webkit-selection": { background: "#B9B9B9", color: "#000000" },
  },
}));

const QueryDialog = (props) => {
  const {
    value,
    handleClose,
    loading,
    isOpen,
    setQueryFromPopup,
    runParams = {},
    location = "SNOWFLAKE",
    type,
    queryLastUpdatedByName,
    queryResultState,
    onQueryRunFromPopup,
    queryRestriction,
  } = props;

  const { classes } = useStyles();
  const queryRef = useRef(null);

  return (
    <Box>
      <Backdrop sx={{ background: "transparent", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="primary" />
      </Backdrop>
      <KMKDialog
        TransitionComponent={Transition}
        open={isOpen}
        sx={{
          "& .MuiDialog-paperFullScreen": {
            maxHeight: "82%",
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.2)",
            backgroundColor: "#fff",
          },
        }}
        fullScreen
        slotProps={{
          backdrop: {
            style: {
              backgroundColor: "rgba(0, 0, 0, 0.1)",
              backdropFilter: "blur(1px)",
            },
          },
        }}
        PaperProps={{
          sx: {
            m: "130px 42px 0 110px",
            borderRadius: "20px",
          },
        }}
      >
        <DialogTitle sx={{ padding: "0" }}>
          <AppBar sx={{ position: "relative" }}>
            <Toolbar className={classes.Toolbar}>
              <Typography sx={{ ml: 2, flex: 1 }} variant="body1" component="div">
                {queryLastUpdatedByName ? `Query * (Last updated by: ${queryLastUpdatedByName})` : `Query *`}
              </Typography>
              <Tooltip arrow title="Close Full Screen" disableFocusListener placement="top-start">
                <IconButton
                  edge="end"
                  color="inherit"
                  onClick={handleClose}
                  style={{ marginRight: 15 }}
                  aria-label="close"
                >
                  <ZoomInMapIcon />
                </IconButton>
              </Tooltip>
            </Toolbar>
          </AppBar>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <Box sx={{ width: "100%", height: "100%" }} className={classes.container}>
            <Box sx={{ mb: 2 }} className={classes.bodyContainer}>
              <Grid sx={{ paddingTop: "2px !important" }} size={12}>
                <ComponentSuspense>
                  <MyAceEditor
                    fontSize={14}
                    style={{ paddingTop: "10px" }}
                    className={classes.queryArea}
                    ref={queryRef}
                    label="Query"
                    value={value}
                    onLoad={(editorInstance) => {
                      editorInstance.container.style.resize = "both";
                      // mouseup = css resize end
                      document.addEventListener("mouseup", (e) => editorInstance.resize());
                    }}
                    setQuery={setQueryFromPopup}
                    location={location}
                    type={type}
                    runParams={runParams}
                    queryRestriction={queryRestriction}
                    /**
                     * Important params for popup
                     */
                    fromPopup={true}
                    resultFromPopup={queryResultState}
                    onQueryRunFromPopup={onQueryRunFromPopup}
                  />
                </ComponentSuspense>
              </Grid>
            </Box>
          </Box>
        </DialogContent>
      </KMKDialog>
    </Box>
  );
};

export default QueryDialog;
